import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { navigate } from 'gatsby'
import GatsbyImage from 'gatsby-image'
import Tag from 'src/components/molecules/Tag'
import OmittedText from 'src/components/atoms/OmittedText'
import { Typography } from 'src/components/atoms/Typography'
import { BreakPoint } from 'src/components/shared/CssValues'

const SeminarCard = ({
  title,
  description,
  thumbnail,
  tags,
  date,
  to,
  ...props
}) => {
  const handleClick = () => navigate(to)

  return (
    <Card {...props} onClick={handleClick}>
      {thumbnail && (
        <Thumbnail
          fluid={thumbnail.childImageSharp.fluid}
          imgStyle={{ objectFit: 'contain' }}
        />
      )}
      <Summary>
        <Title as="h3">{title}</Title>
        <Description
          as="p"
          css={descriptionCss}
          fontSize={14}
          lineHeight={1.4}
          lines={3}
          spLines={4}
          value={description}
        />
        <Meta>
          {Array.isArray(tags) && (
            <Tags>
              {tags.map(tag => {
                if (!tag) {
                  return
                }
                return (
                  <Tag key={tag} small isHighlight>
                    {tag}
                  </Tag>
                )
              })}
            </Tags>
          )}
          <Date as="p">{date}</Date>
        </Meta>
      </Summary>
    </Card>
  )
}

const Card = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 36px;
  box-sizing: border-box;
  width: 100%;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;

  & > * + * {
    margin: 0 0 0 40px;

    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      margin: 24px 0 0;
    }
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    flex-direction: column;
    padding: 16px 16px 25px;
  }
`

const Thumbnail = styled(GatsbyImage)`
  width: 280px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const Summary = styled.div`
  width: 591px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const Title = styled(Typography)`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  color: #22475d;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 18px;
  }
`

const Text = styled(Typography)`
  font-size: 14px;
  line-height: 22.4px;
`

const Description = styled(OmittedText)``

const descriptionCss = css`
  margin-top: 24px;
`

const Tags = styled.div`
  & > * + * {
    margin-left: 10px;
  }
`

const Date = styled(Text)``

const Meta = styled.div`
  display: flex;
  justify-content: start;
  margin-top: 19px;

  & > ${Tags} + ${Date} {
    margin-left: 18px;
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-top: 27px;
    justify-content: space-between;
  }
`

export default SeminarCard
